<ion-grid class="container">
  <ion-row class="ion-align-items-center">
    <ion-col class="header--left">
      <ion-img src="/assets/img/ai-analytics-logo.svg" alt="AI Analytics"></ion-img>
    </ion-col>

    <ion-col class="header--middle">
      <span>{{ 'aiAnalytics.ChatbotAi' | translate }}</span>
    </ion-col>

    <ion-col class="header--right">
      <ion-button
        *ngIf="
          componentInputs &&
          componentInputs.type === 'TABLE' &&
          componentInputs.data.status === 'success' &&
          !isMobileScreen
        "
        fill="clear"
        (click)="downloadCsv(componentInputs.data.headers, componentInputs.data.query_results)"
        class="ion-no-margin"
      >
        <ion-img src="assets/img/download-outline-black.svg" alt="Download"></ion-img>
      </ion-button>
    </ion-col>

    <ion-col class="header--right">
      <ion-button fill="clear" (click)="closeModal()" class="ion-no-margin">
        <ion-img src="/assets/img/close.svg" alt="Close"></ion-img>
      </ion-button>
    </ion-col>
  </ion-row>

  <ion-row class="content">
    <ion-col *ngIf="componentInputs">
      <monorepo-ui-charts
        *ngIf="componentInputs.type === 'CHART'"
        [highChartsConfig]="componentInputs.chartModel"
      ></monorepo-ui-charts>

      <ui-table *ngIf="componentInputs.type === 'TABLE'" [zTableModel]="componentInputs.tableModel"></ui-table>
    </ion-col>
  </ion-row>
</ion-grid>
